import React from 'react';
import classNames from 'classnames';

import styles from './CheckboxInput.module.scss';

function CheckboxInput({ className, children, ...remainingProps }) {
  return (
    <label className={classNames('row align-c cursor', styles.root, className)}>
      <div className="flex-fill m-r-xxs">{children}</div>
      <input
        type="checkbox"
        className={styles.input}
        {...remainingProps}
      />
    </label>
  );
}

export default CheckboxInput;
